import { AddRaterModal } from "./AddRaterModal";
import { useState } from "react";

export default function AddRaters({formik, isErrorNoOfRaterGroup, setIsErrorNoOfRaterGroup}) {
    const [show, setShow] = useState(false);
    const [currSubject, setCurrSubject] = useState(false);
    const [currSubjectIndex, setCurrSubjectIndex] = useState();
    // const [isErrorNoOfRaterGroup, setIsErrorNoOfRaterGroup] = useState(false);

    const checkRaters = (index) => {
        // console.log("index",index)
        return new Promise((resolve)=>{
            let isError = false
            let errorMsg = ''
            if(formik.values.subjects[index]?.subject_raters){
                let raters = formik.values.subjects[index].subject_raters;
                let groups = {}
                for(let rater of raters){
                    if(groups[rater.raterGroup.name]){
                        groups[rater.raterGroup.name] = groups[rater.raterGroup.name] + 1
                    }
                    else{
                        groups[rater.raterGroup.name] = 1
                    }
                }
                // console.log("groups-------------------------", groups)
                let raterGroups = formik.values.raterGroups;
                for(let raterGroup of raterGroups){
                    // only validate groups where min_one_rater = 1
                    if(raterGroup.min_one_rater == 1){
                        let count = groups[raterGroup.name] ? groups[raterGroup.name] : 0;

                        if(count < 1){

                            if(errorMsg === ''){
                                errorMsg = 'Please add ';
                            }

                            errorMsg += '1 ' + raterGroup.name + ', ';
                        }
                    }
                    else{
                        let count = groups[raterGroup.name] ? groups[raterGroup.name] : 0

                        if(count < 3){
                            if(errorMsg === ''){
                                errorMsg = 'Please add ';
                            }

                            let left = 3 - count

                            errorMsg += left + ' ' + raterGroup.name + ', ';
                        }

                        
                    }
                }
                // let isManagerAdded = false
                // for(let key of Object.keys(groups)){
                //     if(key === 'Manager'){
                //         isManagerAdded = true
                //     }
                //     if(groups[key] < 3 && key !== 'Manager'){
                //         let left = 3 - groups[key]
                //         if(errorMsg === ''){
                //             errorMsg = 'Please add '
                //         }
                //         errorMsg += left+' more '+key.toLowerCase()+', '
                //     }
                // }
                // errorMsg.replace(/,\s*$/, "")
                // if(!isManagerAdded){
                //     if(errorMsg === ''){
                //         errorMsg = 'Please add '
                //     }    
                //     errorMsg += ' 1 manager'
                // }
                // setErrorNoOfRaterGroup(errorMsg.replace(/,\s*$/, ""))
            }        
            // console.log("errorMsg", errorMsg)
            // console.log("isErrorNoOfRaterGroup", isErrorNoOfRaterGroup)
            if(errorMsg !== '' && isErrorNoOfRaterGroup === false){
                isError = true
                setIsErrorNoOfRaterGroup(true)
            }
            // console.log()
            resolve(errorMsg)
        })
        
    }

    return (
        <>
        <div className="row py-4">
            <div className="col-md-8 offset-md-2 mt-4">
                <h3 className="heading fs_20">Add Raters</h3>
                <div className="row">
                    
                    <table className="table mb-0">
                        <thead>
                            <tr>
                            <th scope="col">S. No.</th>
                            <th scope="col">Subject Name</th>
                            <th scope="col">Subject Email</th>
                            <th scope="col">Raters</th>                                                
                            </tr>
                        </thead>
                        <tbody>
                            {formik.values.subjects.map((subject, index) => (
                                <tr key={"sr"+index} 
                                    // style={{backgroundColor: checkRaters(index) !== '' ? '#ffffb1' : '' }}
                                >
                                    <th scope="row">{index + 1}</th>
                                    <td>{subject.firstName+' '+subject.lastName}</td>
                                    <td>{subject.email}</td>
                                    <td>
                                        <button className="btn ss_btn bg-transparent" onClick={() => {setShow(true); setCurrSubject(subject); setCurrSubjectIndex(index)}}>Add Raters</button>
                                    </td>                                               
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {isErrorNoOfRaterGroup ? <div className="text-danger">Please add required no. of raters within each group for the highlighted subjects</div> : ''}
            </div>
        </div>
        <AddRaterModal show={show} setShow={setShow} formik={formik} currSubject={currSubject} currSubjectIndex={currSubjectIndex}/>
        </>
    )
}